import page from '../utils/rbata.page';
import scrollToTop from '../utils/rbata.scrollToTop';

const mobileNav = {
    ACTIVE_CLASS:         'active',
    ACTIVE_SCROLL:        'mobile-nav__scroll--active',
    $mobileHeader:        undefined,
    $anchorLink:          undefined,
    $anchorGround:        undefined,
    $goBackArrow:         undefined,
    $parentCategoryName:  undefined,
    $mobileLogo:          undefined,
    $mobileSearch:        undefined,
    $mobileNavScrollable: undefined,
    $mobileNavUtility:    undefined,

    cacheSelectors: () => {
        mobileNav.$mobileHeader = $('.page-header__mobile');
        mobileNav.$anchorLink = mobileNav.$mobileHeader.find('.page-header__main-nav-anchor');
        mobileNav.$anchorGround = mobileNav.$mobileHeader.find('.page-header__main-nav-ground');
        mobileNav.$goBackArrow = mobileNav.$mobileHeader.find('.page-header__arrow-back');
        mobileNav.$parentCategoryName = mobileNav.$mobileHeader.find('.page-header__parent-category');
        mobileNav.$mobileLogo = mobileNav.$mobileHeader.find('.header__logo');
        mobileNav.$mobileSearch = mobileNav.$mobileHeader.find('.page-header__search');
        mobileNav.$mobileNavScrollable = mobileNav.$mobileHeader.find('.mobile-nav__scroll');
        mobileNav.$mobileNavUtility = mobileNav.$mobileHeader.find('.nav-utility');
        mobileNav.bindEvents();
    },

    resetPanels: () => {
        const deepestActiveNode = mobileNav.$mobileHeader.find(`.${mobileNav.ACTIVE_CLASS}:last`);
        mobileNav.adjustMobileBarTitle(deepestActiveNode.closest('.page-header__main-nav-list')
                                                        .children(':not(.active)')
                                                        .find('.page-header__main-nav-link')
        );
        deepestActiveNode.removeClass(mobileNav.ACTIVE_CLASS);

        if (mobileNav.$mobileHeader.find(`.${mobileNav.ACTIVE_CLASS}`).length < 1) {
            mobileNav.revealMobileBarControls(false);
        }
    },

    revealMobileBarControls: (value = true) => {
        if (value) {
            mobileNav.$goBackArrow.removeClass('d-none');
            mobileNav.$parentCategoryName.removeClass('d-none');
            mobileNav.$mobileLogo.addClass('d-none');
            mobileNav.$mobileSearch.addClass('d-none');
            mobileNav.$mobileNavUtility.addClass('d-none');
            mobileNav.$mobileNavScrollable.addClass(mobileNav.ACTIVE_SCROLL);
        } else {
            mobileNav.$goBackArrow.addClass('d-none');
            mobileNav.$parentCategoryName.addClass('d-none');
            mobileNav.$mobileLogo.removeClass('d-none');
            mobileNav.$mobileSearch.removeClass('d-none');
            mobileNav.$mobileNavUtility.removeClass('d-none');
            mobileNav.$mobileNavScrollable.removeClass(mobileNav.ACTIVE_SCROLL);
        }
    },

    adjustMobileBarTitle: (parentNodeText) => {
        mobileNav.$parentCategoryName.text(parentNodeText.text());
    },

    bindEvents: () => {
        /**
         * Click on parent category to open child category nav panel
         */
        mobileNav.$anchorLink.on('click', function (evt) {
            const $this = $(this);
            if ($this.siblings(mobileNav.$anchorGround).length) {
                $this.siblings(mobileNav.$anchorGround)
                     .addClass(mobileNav.ACTIVE_CLASS);
                mobileNav.revealMobileBarControls(true);
                mobileNav.adjustMobileBarTitle($this.find('.page-header__main-nav-link')
                );
            }
        });

        /**
         * Click to close active child category nav panel
         */
        mobileNav.$goBackArrow.on('click', function () {
            mobileNav.resetPanels();
        })
    },

    openMobileNavigation() {
        mobileNav.$mobileHeader.addClass('page-header__mobile--open');
        mobileNav.$mobileHeader.removeClass('page-header__mobile--closed');
        page.addBackdrop();
        scrollToTop.backToTopInvisible();
    },

    closeMobileNavigation() {
        mobileNav.$mobileHeader.removeClass('page-header__mobile--open');
        setTimeout(() => {
            mobileNav.$mobileHeader.addClass('page-header__mobile--closed');
            mobileNav.$mobileHeader.find(`.${mobileNav.ACTIVE_CLASS}`).removeClass(mobileNav.ACTIVE_CLASS);
            page.addBackdrop(false);
            scrollToTop.backToTopInvisible(false);
        }, 500);
    }
}

$(() => {
    mobileNav.cacheSelectors();
});

export default mobileNav;